// Where we send anyone who has nowhere specific to go: straight after login, on
// any URL that matches no route, and when they click the nav bar logo. All land
// in the new app.
export const DEFAULT_REDIRECT_URL = '/next/dashboard'

// The equivalent landing page for OTSM-only environments with no active vessels.
export const DEFAULT_OTSM_REDIRECT_URL = '/otsm'
